import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { AttributionControl, GeolocateControl, Map } from 'mapbox-gl';
import { GeoPoint } from 'src/app/geopoint';
import { environment } from 'src/environments/environment';

declare var mapboxgl: any;

@Component({
  selector: 'app-tour-map',
  templateUrl: './tour-map.component.html',
  styleUrls: ['./tour-map.component.scss'],
})
export class TourMapComponent implements OnInit, OnChanges {
  mapInstance: Map;
  geoLocationControl: GeolocateControl;
  attributionControl: AttributionControl;
  popup = null;
  next_point: any;
  cur_point: any;
  @Input() currentStop: number = 0;
  @Input() language: 'en' | 'es' = 'en';
  @Input() stopCoordinates: Array<Record<string, any>> = [];
  @Input() paths: Array<any> = [];
  @Output() trackedLocation = new EventEmitter<boolean>();
  @Output() mapLoad = new EventEmitter<void>();

  constructor(
    private changeRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initMap();
  }

  ngOnChanges(changes) {
    console.log('changes', changes);
  }

  initMap() {
    console.log('mapBoxGL', mapboxgl, typeof mapboxgl);
    mapboxgl.accessToken = environment.mapboxToken;
    this.mapInstance = new mapboxgl.Map({
      container: 'map', // container id
      style: 'mapbox://styles/maximus8754/ckgrhdjdw08iw19ql2djh2e9h',
      center: this.stopCoordinates[this.currentStop]  && [
        this.stopCoordinates[this.currentStop]?.coordinates.longitude,
        this.stopCoordinates[this.currentStop]?.coordinates.latitude,
      ] || [
        this.stopCoordinates[0]?.coordinates.longitude,
        this.stopCoordinates[0]?.coordinates.latitude,
      ], // starting position
      zoom: 16, // starting zoom
      dragPan: {
        linearity: 0.1,
        // easing: "bezier(0, 0, 0.3, 1)",
        maxSpeed: 1,
        deceleration: 200,
      },
    });
    this.mapInstance.scrollZoom.setZoomRate(1 / 1000);
    this.geoLocationControl = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: true,
      showUserHeading: true,
    });
    this.geoLocationControl.on('error', (e) => {
      this.trackedLocation.emit(false);
      this.changeRef.detectChanges();
    });
    this.geoLocationControl.once('geolocate', (e) => {
      this.trackedLocation.emit(true);
      this.changeRef.detectChanges();
      const coords = [
        e.coords,
        this.stopCoordinates[this.currentStop]?.coordinates,
      ];
      this.centerMap(coords, 30, true);
    });
    this.attributionControl = new mapboxgl.AttributionControl({
      compact: true,
    });
    this.mapInstance.on('load', this.handleMapLoad.bind(this));
    this.mapInstance.addControl(this.geoLocationControl);
  }

  centerMap = (
    coordinates: Array<GeoPoint>,
    padding: number,
    fromUser: boolean
  ) => {
    if (fromUser) {
      console.log('CENTER map)');
      console.log(coordinates);
      var bounds = coordinates.reduce(function (bounds, coord) {
        return bounds.extend([coord.longitude, coord.latitude]);
      }, new mapboxgl.LngLatBounds(
        [coordinates[0].longitude, coordinates[0].latitude],
        [coordinates[1].longitude, coordinates[1].latitude]
      ));
      this.mapInstance.fitBounds(bounds, {
        padding: { top: 50, bottom: 50, left: 50, right: 50 },
      });
    } else {
      let longSum = 0;
      let latSum = 0;
      for (var i = 0; i < coordinates.length; i++) {
        longSum += coordinates[i].longitude;
        latSum += coordinates[i].latitude;
      }
      let longAvg = longSum / coordinates.length;
      let latAvg = latSum / coordinates.length;
      this.mapInstance.flyTo({
        center: [longAvg, latAvg],
        essential: true,
        speed: 1,
        zoom: 17,
      });
    }
    // console.log(bounds);
    // var bounds = coordinates.reduce(function (bounds, coord) {
    //   console.log(coord);
    //   console.log(bounds);
    //   return bounds.extend(coord);
    // }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[1]));
    // this.mapInstance.fitBounds(bounds, {
    //   padding: padding
    // });
  };

  handleMapLoad() {
    this.mapLoad.emit();
  }

  locateUser() {
    this.geoLocationControl.trigger();
  }

  drawLine(startingPoint: number[], pathCoordinates: any[]) {
    // console.log("drawLine:");
    let feature;
    let speedFactor = 50; // number of frames per longitude degree
    let animation; // to store and cancel the animation
    let startTime = 0;
    let progress = 0;
    let geojson = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: [startingPoint],
          },
        },
      ],
    };
    if (this.mapInstance.getSource('line-animation')) {
      // console.log("HELL");
      (this.mapInstance.getSource('line-animation') as any).setData({
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [startingPoint],
        },
      });
      // console.log("After hell");
    } else {
      this.mapInstance.addSource('line', {
        type: 'geojson',
        data: geojson as any,
      });
      this.mapInstance.addLayer({
        id: 'line-animation',
        type: 'line',
        source: {
          type: 'geojson',
          data: geojson as any,
        },
        layout: {
          'line-cap': 'round',
          'line-join': 'bevel',
        },
        paint: {
          'line-color': '#27ac06',
          'line-width': 7,
        },
      });
      // this.mapInstance.moveLayer('line-animation', 'sonomatour');
    }
    var diffX = [];
    var diffY = [];
    for (var i = 0; i < pathCoordinates.length - 1; i++) {
      diffX.push(
        Math.abs(
          Math.abs(pathCoordinates[i].longitude) -
            Math.abs(pathCoordinates[i + 1].longitude)
        )
      );
      diffY.push(
        Math.abs(
          Math.abs(pathCoordinates[i].latitude) -
            Math.abs(pathCoordinates[i + 1].latitude)
        )
      );
    }

    // var diffX = -122.434297 - 0;
    // var diffY = 38.278688 - 0;
    var sfX = [];
    var sfY = [];
    for (var iter = 0; iter < diffX.length; iter++) {
      // console.log("diffX: " + diffX[iter]);
      var distance = Math.sqrt(
        Math.pow(diffX[iter], 2) + Math.pow(diffY[iter], 2)
      );
      console.log(distance);
      var spf = distance * 100000;
      sfX.push(diffX[iter] / spf);
      sfY.push(diffY[iter] / spf);
    }

    // var sfX = diffX[0] / speedFactor;
    // var sfY = diffY[0] / speedFactor;

    var i = 0;
    var j = 0;

    var x = 0;
    var y = 0;
    var path_iter = 0;

    var lineCoordinates = [];

    while (
      Math.abs(i) < Math.abs(diffX[x]) ||
      Math.abs(j) < Math.abs(diffY[y])
    ) {
      lineCoordinates.push([
        pathCoordinates[x].longitude + i,
        pathCoordinates[x].latitude + j,
      ]);

      if (Math.abs(i) < Math.abs(diffX[x])) {
        if (pathCoordinates[x + 1].longitude < pathCoordinates[x].longitude) {
          i -= sfX[x];
        } else {
          i += sfX[x];
        }
        if (Math.abs(i) >= Math.abs(diffX[x]) && x < diffX.length) {
          i = 0;
          x++;
          y++;
          j = 0;
        }
      }

      if (Math.abs(j) < Math.abs(diffY[y])) {
        if (pathCoordinates[y + 1].latitude < pathCoordinates[y].latitude) {
          j -= sfY[y];
        } else {
          j += sfY[y];
        }
      }
    }

    var animationCounter = 0;
    // progress = timestamp - startTime;
    var animateLine = () => {
      if (animationCounter < lineCoordinates.length) {
        geojson.features[0].geometry.coordinates.push(
          lineCoordinates[animationCounter]
        );
        (this.mapInstance.getSource('line-animation') as any).setData(geojson);
        animationCounter++;
        requestAnimationFrame(animateLine);
      } else {
        var coord = geojson.features[0].geometry.coordinates;
        coord.shift();
        if (coord.length > 0) {
          geojson.features[0].geometry.coordinates = coord;
          (this.mapInstance.getSource('line-animation') as any).setData(
            geojson
          );
          //-------------- Point2 Animation End ---------------
          console.log('END OF ANIMATION?');
          // this.arrived.emit(true);
        }
      }
    };
    animateLine();
  }

  drawStartingPoint() {
    let markerTxt = 'Starting Location';
    if (this.language == 'es') {
      markerTxt = 'Ubicación de Inicio';
    }

    const startingPointCoordinates = [
      this.stopCoordinates[this.currentStop]?.coordinates.longitude,
      this.stopCoordinates[this.currentStop]?.coordinates.latitude,
    ];

    // if (this.stopNumber == 0) {
    const markerHeight = 10,
      markerRadius = 5,
      linearOffset = 0;
    const popupOffsets = {
      top: [0, 5],
      'top-left': [0, 0],
      'top-right': [0, 0],
      bottom: [0, -markerHeight],
      'bottom-left': [
        linearOffset,
        (markerHeight - markerRadius + linearOffset) * -1,
      ],
      'bottom-right': [
        -linearOffset,
        (markerHeight - markerRadius + linearOffset) * -1,
      ],
      left: [markerRadius, (markerHeight - markerRadius) * -1],
      right: [-markerRadius, (markerHeight - markerRadius) * -1],
    };
    this.popup = new mapboxgl.Popup({
      offset: popupOffsets,
      className: 'map-popup',
      closeButton: false,
      closeOnClick: false,
    })
      .setLngLat(startingPointCoordinates)
      .setHTML('<p class="mb-0">' + markerTxt + '</p>')
      .setMaxWidth('300px')
      .addTo(this.mapInstance);

    // }
    console.log('startingPoint', startingPointCoordinates);

    // let geojson = {
    //   type: 'FeatureCollection',
    //   features: [
    //     {
    //       type: 'Feature',
    //       geometry: {
    //         type: 'LineString',
    //         coordinates: [startingPoint],
    //       },
    //     },
    //   ],
    // };
    // this.mapInstance.addSource('line', {
    //   type: 'geojson',
    //   data: geojson as any,
    // });
    // this.mapInstance.addLayer({
    //   id: 'line-animation',
    //   type: 'line',
    //   source: {
    //     type: 'geojson',
    //     data: geojson as any,
    //   },
    //   layout: {
    //     'line-cap': 'round',
    //     'line-join': 'bevel',
    //   },
    //   paint: {
    //     'line-color': '#27ac06',
    //     'line-width': 7,
    //   },
    // });
    const currentPoint = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: startingPointCoordinates,
          },
        },
      ],
    };
    this.mapInstance.addSource('current-point', {
      type: 'geojson',
      data: currentPoint as any,
    });
    this.mapInstance.addLayer({
      id: 'next',
      type: 'circle',
      source: 'current-point',
      paint: {
        // make circles larger as the user zooms from z12 to z22
        'circle-radius': {
          stops: [
            [14, 5],
            [17, 10],
            [19, 16],
            [22, 21],
          ],
        },
        'circle-color': '#da705d',
        'circle-stroke-color': '#f4f4c7',
        'circle-stroke-width': 2,
      },
    });
    // this.cur_point = {
    //   type: 'FeatureCollection',
    //   features: [],
    // };
    // this.mapInstance.addSource('current-point', {
    //   type: 'geojson',
    //   data: this.cur_point,
    // });
    // this.mapInstance.addLayer({
    //   id: 'current',
    //   type: 'circle',
    //   source: 'current-point',
    //   paint: {
    //     'circle-radius': {
    //       stops: [
    //         [14, 5],
    //         [17, 10],
    //         [19, 16],
    //         [22, 21],
    //       ],
    //     },
    //     'circle-color': '#5B934E',
    //     'circle-stroke-color': '#f4f4c7',
    //     'circle-stroke-width': 2,
    //   },
    // });
  }

  drawPointsWithLine() {
    let markerTxt = 'Starting Location';
    if (this.language == 'es') {
      markerTxt = 'Ubicación de Inicio';
    }

    const startingPointCoordinates = [
      this.stopCoordinates[this.currentStop - 1]?.coordinates.longitude,
      this.stopCoordinates[this.currentStop - 1]?.coordinates.latitude,
    ];

    const nextPointCoordinates = [
      this.stopCoordinates[this.currentStop]?.coordinates.longitude,
      this.stopCoordinates[this.currentStop]?.coordinates.latitude,
    ];

    const currentPoint = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: startingPointCoordinates,
          },
        },
      ],
    };
    this.mapInstance.addSource('current-point', {
      type: 'geojson',
      data: currentPoint as any,
    });
    this.mapInstance.addLayer({
      id: 'current',
      type: 'circle',
      source: 'current-point',
      paint: {
        // make circles larger as the user zooms from z12 to z22
        'circle-radius': {
          stops: [
            [14, 5],
            [17, 10],
            [19, 16],
            [22, 21],
          ],
        },
        'circle-color': '#27ac06',
        // 'circle-color': '#da705d',
        'circle-stroke-color': '#f4f4c7',
        'circle-stroke-width': 2,
      },
    });

    const geojson = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: [startingPointCoordinates],
          },
        },
      ],
    };
    this.mapInstance.addSource('line', {
      type: 'geojson',
      data: geojson as any,
    });
    this.mapInstance.addLayer({
      id: 'line-animation',
      type: 'line',
      source: {
        type: 'geojson',
        data: geojson as any,
      },
      layout: {
        'line-cap': 'round',
        'line-join': 'bevel',
      },
      paint: {
        'line-color': '#27ac06',
        'line-width': 7,
      },
    });
    const nextPoint = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: nextPointCoordinates,
          },
        },
      ],
    };
    this.mapInstance.addSource('next-point', {
      type: 'geojson',
      data: nextPoint as any,
    });
    this.mapInstance.addLayer({
      id: 'next',
      type: 'circle',
      source: 'next-point',
      paint: {
        // make circles larger as the user zooms from z12 to z22
        'circle-radius': {
          stops: [
            [14, 5],
            [17, 10],
            [19, 16],
            [22, 21],
          ],
        },
        'circle-color': '#da705d',
        'circle-stroke-color': '#f4f4c7',
        'circle-stroke-width': 2,
      },
    });
    const path_coordinates = this.paths[this.currentStop -1];
    console.log("PATH COORDINATES: ");
    console.log(path_coordinates);
    this.centerMap(path_coordinates, 30, false);
    const start_point = [this.paths[this.currentStop-1][0].longitude, this.paths[this.currentStop-1][0].latitude]
    this.drawLine(start_point, path_coordinates);
  }

  moveToNextStop() {}
}
